// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.provider-search {
}

	.provider-search .search-bar {
		background: #f9f9f9;
		padding: 16px;
		border-bottom: solid 1px #b2b2b2;
	}

	.provider-search .search-wrap {
		position: relative;
	}

		.provider-search .search-wrap .fa {
			position: absolute;
			left: 8px;
			top: 8px;
			color: #8e8e92;
			font-size: 17px;
		}

	.provider-search .search-bar input {
		width: 100%;
		box-sizing: border-box;
		height: 36px;
		border-radius: 5px;
		border: none;
		background: #e8e8e9;
		font-size: 17px;
		padding-left: 30px;
	}

	.provider-search .provider {
		font-size: 17px;
		line-height: 20px;
		padding-top: 12px;
		padding-bottom: 12px;
		margin-left: 16px;
		margin-right: 16px;
		cursor: pointer;
		border-bottom: solid 1px #c7c7cb;
	}

		.provider-search .provider:last-child {
			border-bottom: none;
		}

	.provider-search .no-results {
		padding: 16px;
		font-size: 17px;
	}
`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Views/ProviderSearch.css"],"names":[],"mappings":"AAAA;AACA;;CAEC;EACC,mBAAmB;EACnB,aAAa;EACb,gCAAgC;CACjC;;CAEA;EACC,kBAAkB;CACnB;;EAEC;GACC,kBAAkB;GAClB,SAAS;GACT,QAAQ;GACR,cAAc;GACd,eAAe;EAChB;;CAED;EACC,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;CACjC;;EAEC;GACC,mBAAmB;EACpB;;CAED;EACC,aAAa;EACb,eAAe;CAChB","sourcesContent":[".provider-search {\n}\n\n\t.provider-search .search-bar {\n\t\tbackground: #f9f9f9;\n\t\tpadding: 16px;\n\t\tborder-bottom: solid 1px #b2b2b2;\n\t}\n\n\t.provider-search .search-wrap {\n\t\tposition: relative;\n\t}\n\n\t\t.provider-search .search-wrap .fa {\n\t\t\tposition: absolute;\n\t\t\tleft: 8px;\n\t\t\ttop: 8px;\n\t\t\tcolor: #8e8e92;\n\t\t\tfont-size: 17px;\n\t\t}\n\n\t.provider-search .search-bar input {\n\t\twidth: 100%;\n\t\tbox-sizing: border-box;\n\t\theight: 36px;\n\t\tborder-radius: 5px;\n\t\tborder: none;\n\t\tbackground: #e8e8e9;\n\t\tfont-size: 17px;\n\t\tpadding-left: 30px;\n\t}\n\n\t.provider-search .provider {\n\t\tfont-size: 17px;\n\t\tline-height: 20px;\n\t\tpadding-top: 12px;\n\t\tpadding-bottom: 12px;\n\t\tmargin-left: 16px;\n\t\tmargin-right: 16px;\n\t\tcursor: pointer;\n\t\tborder-bottom: solid 1px #c7c7cb;\n\t}\n\n\t\t.provider-search .provider:last-child {\n\t\t\tborder-bottom: none;\n\t\t}\n\n\t.provider-search .no-results {\n\t\tpadding: 16px;\n\t\tfont-size: 17px;\n\t}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
